import styled from 'styled-components';

export const AccountCreatedMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4rem;
        flex-direction: column;
        @media(max-width:1023px){
            padding: 2rem;
        }
    `
);

export const AccountCreatedCommonWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        justify-content: center;
        margin: 2rem 0;
        flex-direction: column;
        align-items: center;
    `
);

export const AccountCreatedBtnWrap = styled.div(
    props => `
        width:50%;
        display: flex;
        justify-content: center;
        margin: 2rem 0;
        flex-direction: column;
        align-items: center;
    `
)

export const AccCreatedHeadText = styled.p(
    props => `
        font-size: 2.8rem;
        color: #000;
        font-weight: 900; 

        @media(max-width:1023px){
            font-size: 2.4rem;
            text-align:center;
        }
    `
);

export const AccCreatedSubHeadText = styled.p(
    props => `
        font-size: 1.6rem;
        color: #000;
        font-weight: bold; 
        text-align:center;
        @media(max-width:1023px){
            font-size: 1.4rem;
            text-align:center;
        }
    `
);

export const AccCreatedInfoHeadText = styled.p(
    props => `
        font-size: 2.0rem;
        color: #000;
        @media(max-width:1023px){
            font-size: 1.4rem;
            text-align:center;
        }
    `
);

export const AccCreatedInfoSubText = styled.p(
    props => `
        font-size: 1.4rem;
        color: #000;
        padding-top:0.5rem;
        @media(max-width:1023px){
            font-size: 1.2rem;
            text-align:center;
        }
    `
);

export const AccCreatedInfoText = styled.p(
    props => `
        font-size: 1.4rem;
        color: rgba(0,0,0,0.8);
        text-align:center;
        @media(max-width:1023px){
            font-size: 1.2rem;
            text-align:center;
        }
    `
);